export default __webpack_public_path__ + "static/media/Linked_List_Insertion_2.6f1c7c2b.gif";